import { axiosInstanceAuth } from "config/axios-config";
import { getToken } from "config/storageController";
import { profileDataMapper } from "utils/requests/authentication";
import { refreshAccessToken } from "utils/requests/auth/refreshToken";

// Verifies the stored token against the server and rehydrates the profile.
const verifyToken = async () => {
  try {
    const { axiosInstance } = axiosInstanceAuth();
    const res = await axiosInstance.post("/verify");

    if (res.data?.success) {
      profileDataMapper(res.data.data);
      return true;
    }
    return false;
  } catch (error) {
    console.error("Error verifying session:", error);
    return false;
  }
};

export const isAuthenticated = async () => {
  const localToken = getToken();

  if (localToken && (await verifyToken())) return true;

  // The access token is missing or no longer valid: try to renew it once using the API's HttpOnly refresh cookie before treating the session as expired.
  const refreshed = await refreshAccessToken();
  if (!refreshed.success) return false;

  return verifyToken();
};
